/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var DynamicMenuSection;
(function (DynamicMenuSection) {
    DynamicMenuSection["HEADER"] = "HEADER";
    DynamicMenuSection["NAVBAR"] = "NAVBAR";
    DynamicMenuSection["QUICKNAV"] = "QUICKNAV";
    DynamicMenuSection["FOOTER"] = "FOOTER";
})(DynamicMenuSection || (DynamicMenuSection = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHluYW1pYy1tZW51LXNlY3Rpb24uZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaGFyZWQvZHluYW1pYy1tZW51L2R5bmFtaWMtbWVudS1zZWN0aW9uLmVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxrQkFLWDtBQUxELFdBQVksa0JBQWtCO0lBQzFCLHVDQUFpQixDQUFBO0lBQ2pCLHVDQUFpQixDQUFBO0lBQ2pCLDJDQUFxQixDQUFBO0lBQ3JCLHVDQUFpQixDQUFBO0FBQ3JCLENBQUMsRUFMVyxrQkFBa0IsS0FBbEIsa0JBQWtCLFFBSzdCIn0=